import { isArray } from 'lodash'

import { CacheFactory } from '../../models/CacheFactory'
import { Device } from '../../models/Device'
import { ISerializable, isSerializable } from '../../models/ISerializable'
import { User } from '../../models/User'

type RouterData = {
    [key: string]:
        | ISerializable
        | string
        | number
        | boolean
        | string[]
        | number[]
        | boolean[]
        | ISerializable[]
        | undefined
}

export const toRouter = (data: RouterData) => {
    const obj: any = { modal: false }
    if (!!data && Object.keys(data)?.length) {
        for (const key in data) {
            if (data[key] === undefined || data[key] === null) continue

            if (isSerializable(data[key])) {
                const item = data[key] as ISerializable
                obj[key] = item.serialize()
            }
            else if (isArray(data[key])) {
                obj[key] = []
                const items = data[key] as string[] | number[] | boolean[] | ISerializable[]
                for (const item of items) {
                    if (isSerializable(item)) {
                        const serializable = item as ISerializable
                        obj[key].push(serializable.serialize())
                    }
                    else {
                        obj[key].push(item)
                    }
                }
            }
            else {
                obj[key] = data[key]
            }
        }
    }
    return obj
}

export class PSApplication {
    private static instance: PSApplication | null = null
    public static getInstance() {
        try {
            if (PSApplication.instance == null) {
                PSApplication.instance = new PSApplication()
            }
            return PSApplication.instance
        }
        catch {
            window.location.href = '/logout'
        }
    }

    public static userId(): string {
        try {
            return CacheFactory.getInstance().userId
        }
        catch {
            window.location.href = '/logout'
            throw new Error('Failed to get user id')
        }
    }

    public static deviceId(): string {
        try {
            return CacheFactory.getInstance().deviceId
        }
        catch {
            window.location.href = '/logout'
            throw new Error('Failed to get device id')
        }
    }

    public static me(): User {
        try {
            return CacheFactory.getInstance().currentUser()!
        }
        catch {
            window.location.href = '/logout'
            throw new Error('Failed to get current user')
        }
    }

    public static owner(): User {
        try {
            return PSApplication.me().owner!
        }
        catch {
            window.location.href = '/logout'
            throw new Error('Failed to get owner')
        }
    }

    public static role(): number {
        try {
            return PSApplication.me().perm!
        }
        catch {
            window.location.href = '/logout'
            throw new Error('Failed to get role')
        }
    }

    public static inbox(): string {
        try {
            return PSApplication.role() === User.PERM_ROLE_ADMIN
                ? PSApplication.me().inbox!
                : PSApplication.userId()
        }
        catch {
            window.location.href = '/logout'
            throw new Error('Failed to get inbox')
        }
    }

    public static device(): Device {
        try {
            return CacheFactory.getInstance().currentDevice()!
        }
        catch {
            window.location.href = '/logout'
            throw new Error('Failed to get device')
        }
    }
}
